import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Stack, Typography } from "@mui/material";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { FilterEntry, FilterType } from "hooks/filters";
import { type Dispatch, type FC, useMemo } from "react";

export interface PropertiesFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  brands?: Array<AutocompleteData>;
  gradeNumbers?: Array<AutocompleteData>;
  t: (key: string) => string;
}

export const PropertiesFilter: FC<PropertiesFilterProps> = ({
  value = [],
  onChange,
  brands,
  gradeNumbers,
  t,
}) => {
  const filters: Array<FilterEntry> = useMemo(
    () =>
      [
        {
          type: "brand" as FilterType,
          value: brands,
        },
        {
          type: "gradeNumber" as FilterType,
          value: gradeNumbers,
        },
      ].filter((e) => e.value !== undefined && e.value.length > 0),
    [brands, gradeNumbers],
  );

  return (
    <ColorSearchAutocomplete
      label={t("filter_grade_properties")}
      example={"RE"}
      type="gradeProperty"
      value={value}
      onChange={onChange}
      limit={500}
      filters={filters}
      formatOptionLabel={(option) => option.value}
      formatOptionText={(option) => (
        <Stack
          direction="row"
          width="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography>{option.value}</Typography>
          <Typography
            color="text.secondary"
            fontSize="var(--body-b3-12-regular-size, 12px)"
            fontStyle="italic"
            align="right"
            sx={{ maxWidth: "80%" }}
          >
            {option.name}
          </Typography>
        </Stack>
      )}
    />
  );
};
